import React from 'react';
import Grid from '@material-ui/core/Grid';
import AddAlert from '@material-ui/icons/AddAlert';
import Snackbar from '../../../components/sharedComponents/Snackbar/Snackbar';
import TableType2 from '../../../components/sharedComponents/Tablas/TableType2/TableType2';
import { permitsList } from '../../../constants/permits';
import CardTitle from '../../../components/sharedComponents/CardTitle';

const ProjectionsPage = ({
  industries,
  releases,
  permisos,
  loading,
  onUpdateIndustrie,
  onUpdateRelease,
}) => {
  const columns = [
    { title: 'Mes', field: 'mes', editable: 'never' },
    { title: 'Año', field: 'año', editable: 'never' },
    { title: 'Empresa', field: 'empresa', editable: 'never' },
    { title: 'Valor', field: 'valor', type: 'numeric' },
  ];

  const columnsRelease = [
    { title: 'Mes', field: 'mes', editable: 'never' },
    { title: 'Año', field: 'año', editable: 'never' },
    { title: 'Linea', field: 'linea', editable: 'never' },
    { title: 'Meta Mes', field: 'meta', type: 'numeric' },
  ];

  const open = typeof (loading) === 'object' ? loading.loIndustri : loading
  return (
    <>
      <Snackbar
        place="tr" // Depende la dirección en la que se va a mostrar
        color="warning"
        icon={AddAlert}
        message="Actualización en progreso...."
        open={open}
      />
      <Grid container>
        {permisos[permitsList.PROYECCION_INDUSTRIA] && (
          <Grid item xs={12}>
            <CardTitle title="Tabla de Industria" />
            <TableType2
              dataTable={industries}
              idPermiso={permitsList.PROYECCION_INDUSTRIA}
              onUpdate={onUpdateIndustrie}
              minValue={permisos[permitsList.PROYECCION_INDUSTRIA]}
              columns={columns}
              loading={loading.loIndustri}
            />
          </Grid>
        )}
        {permisos[permitsList.PROYECCION_LANZAMIENTO] && (
          <Grid item xs={12}>
            <CardTitle title="Tabla de Lanzamientos" />
            <TableType2
              dataTable={releases}
              columns={columnsRelease}
              onUpdate={onUpdateRelease}
              loading={loading.loreleases}
              idPermiso={permitsList.PROYECCION_LANZAMIENTO}
              minValue={permisos[permitsList.PROYECCION_LANZAMIENTO]}
            />
          </Grid>
        )}
      </Grid>
    </>
  );
};

export default ProjectionsPage;
